import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addLease = (lease, token) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/lease/create", {
    agreementId: +lease.agreementId,
    vehicleId: +lease.vehicle,
    driverId: +lease.driver
  }, config);
};

const updateLease = (lease, token) => {
  const config = configurationForToken(token);
  return apiClient.put("/admin/lease/edit", {
    id: +lease.id,
    agreementId: lease.agreementId,
    vehicleId: +lease.vehicle,
    driverId: +lease.driver
  }, config);
};

const deleteLease = (leaseId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/admin/lease/delete", { data: {id: leaseId}, ...config });
};

const allLeases = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/lease/all", config);
};

export default {
  addLease,
  updateLease,
  deleteLease,
  allLeases,
};



// WEBPACK FOOTER //
// ./src/Services/LeaseService.js